import { sec2toHHMMSS } from 'helpers';

const shaka = require('external/shaka-player.ui.debug');

const SeekbarFloatingTime = class extends shaka.ui.Element {
  _element: HTMLDivElement;

  constructor(parent: typeof SeekbarFloatingTime, controls: ShakaControl) {
    super(parent, controls);

    this._element = document.createElement('div');
    this._element.classList.add('shaka-floating-time');
    this.parent.appendChild(this._element);

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this;

    controls.addEventListener('seekBarMouseOver', function (event) {
      const { progress, screenX, seekBarHorizontalMargin } = event;
      const halfWidth = _this._element.clientWidth / 2;
      const video = controls.player_.getMediaElement();
      _this._element.textContent = sec2toHHMMSS((progress || 0) * (video.duration || 0));
      _this._element.style.left = `${Math.min(
        Math.max(screenX, seekBarHorizontalMargin + halfWidth),
        window.innerWidth - seekBarHorizontalMargin - halfWidth,
      )}px`;
      _this._element.classList.add('visible');
    });

    controls.addEventListener('seekBarMouseOut', function () {
      _this._element.classList.remove('visible');
    });
  }
};

// Factory that will create a button at run time.
SeekbarFloatingTime.Factory = class {
  create(rootElement, controls) {
    return new SeekbarFloatingTime(rootElement, controls);
  }
};

export default SeekbarFloatingTime;
